<mat-card *appRole="['CuentasContable.Ver']">
    <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>
    <button mat-button *appRole="['CuentasContable.Crear']" (click)="openDialog('Agregar',cuentaContablePersonsDto)" mat-flat-button color="primary">
      <mat-icon>fact_check</mat-icon>
      Asignar cuenta contable
  </button>
    <br>
    <br>
    <mat-form-field class="example-full-width">
        <mat-label>Buscar</mat-label>
        <input matInput type="search" (keyup)="applyFilter($event)">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <br>

    <table mat-table [dataSource]="dataSource" [hidden]=!data table matSort matSortStart="asc" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
  The actual rendered columns are set as a property on the row definition" -->

        <!-- Id Column -->
        <!-- <ng-container matColumnDef="id">
            <mat-header-cell mat-header-cell *matHeaderCellDef> # </mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
        </ng-container> -->

        <!-- CC Descripcion Column -->
        <ng-container matColumnDef="cuentaContableDescripcion">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> CC Descripcion </mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element"> {{element.cuentaContable.descripcion}} </mat-cell>
        </ng-container>

        <!-- CC CBU Column -->
        <ng-container matColumnDef="cuentaContableCbu">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> CC Cbu </mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element">{{element.cuentaContable.cbu}} </mat-cell>
        </ng-container>

        <!-- CC Alias Column -->
        <ng-container matColumnDef="cuentaContableAlias">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> CC Alias </mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element"> {{element.cuentaContable.alias}} </mat-cell>
        </ng-container>



        <!-- Descripcion Column -->
        <ng-container matColumnDef="descripcion">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> Detalle </mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element"> {{element.descripcion}} </mat-cell>
        </ng-container>

        <!-- Activo Column -->
        <ng-container matColumnDef="activo">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> Activo </mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element">
                <mat-icon color="primary" *ngIf="element.activo == true">done</mat-icon>
                <mat-icon color="primary" *ngIf="element.activo == false">close</mat-icon>
            </mat-cell>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="accion">
            <mat-header-cell mat-header-cell *matHeaderCellDef> Acción </mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element" class="action-link">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
                <mat-menu #menu="matMenu">
                    <!-- <button mat-menu-item [routerLink]="['/contratos',contrato.id]">
                    <mat-icon>visibility</mat-icon>
                    <span>Ver</span>
                  </button> -->
                    <button *appRole="['CuentasContable.Modificar']" mat-menu-item (click)="openDialog('Modificar',element)">
                    <mat-icon>edit</mat-icon>
                    <span>Editar</span>
                  </button>
                    <button *appRole="['CuentasContable.Eliminar']" mat-menu-item (click)="openDialogDelete('Eliminar',element)">
                    <mat-icon>delete</mat-icon>
                    <span>Eliminar</span>
                  </button>
                </mat-menu>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </table>
    <div class="no-data-table">
        <span class="with-icon" *ngIf="dataSource.data.length == 0"><mat-icon>search_off</mat-icon>No se encontraron datos para mostrar.</span>
    </div>
    <mat-paginator showFirstLastButtons class="paginator" [hidden]=!data [pageSize]="10" [pageSizeOptions]="[5, 10, 20,50,100,200]">
    </mat-paginator>

</mat-card>
